import { useSyncExternalStore } from 'react'

// Screens with a sticky bottom element (the mobile tab bar today) publish its
// height here so bottom-anchored toasts can clear it. The tab bar is route-
// gated as well as width-gated, so a hardcoded reserve would leave a gap on
// routes that don't render it.
let currentInset = 0
const subscribers = new Set<() => void>()

export const setToastBottomInset = (px: number) => {
  if (px === currentInset) return

  currentInset = px
  subscribers.forEach((notify) => notify())
}

const subscribe = (notify: () => void) => {
  subscribers.add(notify)

  return () => {
    subscribers.delete(notify)
  }
}

const getSnapshot = () => currentInset

const getServerSnapshot = () => 0

export const useToastBottomInset = () =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
